import { useEffect, useRef } from "react"
import ArchiveUndo from "./ArchiveUndo"
import Filters from "./Filters"
import Tabs from "./Tabs"
import TeeUpList from "./TeeUpList"
import { useFetchTeeUps } from "./hooks/useFetchTeeUps"
import useFetchUsers from "./hooks/useFetchUsers"
import useFetchCalendarEvents from "./hooks/useFetchCalendarEvents"
import UnderlineModal from "./TeeUpList/Modals/UnderlineModal"
import Breadcrumb from "@components/Breadcrumb"
import { setTeeupActive } from "@actions/activeTeeupActions"
import { initialTeeup } from "@config/enums"

// TODO: remove TeeUps folder in the future, rename TeeUpsNd to TeeUps
const TeeUps = () => {
  const { fetchPaginatedTeeups } = useFetchTeeUps()

  // Clear the active teeup when entering the inbox (navigating away from a detail page).
  // This MUST live here, not inside useFetchTeeUps, because TeeupPageContent (detail page)
  // also calls useFetchTeeUps — putting the reset there caused a 10Hz re-fetch loop.
  useEffect(() => {
    setTeeupActive(initialTeeup)
  }, [])
  useFetchUsers()
  useFetchCalendarEvents()

  return (
    <div
      className="relative !overflow-x-hidden max-h-[100vh] pb-4"
      id="infinite-scroll-target">
      {/* INBOX-REBUILD 2026-07-03: breadcrumb header, structured so future Inbox CO types
          (Requests, etc.) become natural siblings later -- a single active crumb today.
          PEOPLE-ALIGN 2026-07-03: now the shared @components/Breadcrumb, also used by
          PeoplePage ("People › @handle") for literal DOM/class parity. */}
      <Breadcrumb testId="inbox-breadcrumb" root="Inbox" current="TeeUps" />
      <Tabs />
      <Filters />
      <TeeUpList fetchTeeUps={fetchPaginatedTeeups} />

      <ArchiveUndo />
      <UnderlineModal />
      {/* WINDOW-ARCH 2026-07-03: CooweAI now mounts ONCE at the app shell (App.js) as a
          true side window beside the content window -- per-page mount removed. */}
    </div>
  )
}

export default TeeUps
